import React from "react";
import type { IconProps } from "./type";
import { COLORS } from "@/app/common/consts/colors";

const LikeIcon = ({ color = "gray" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M14.1667 3.3335C11.5 3.3335 10 5.55572 10 6.66683C10 5.55572 8.5 3.3335 5.83333 3.3335C3.16667 3.3335 2.5 5.55572 2.5 6.66683C2.5 12.5002 10 16.6668 10 16.6668C10 16.6668 17.5 12.5002 17.5 6.66683C17.5 5.55572 16.8333 3.3335 14.1667 3.3335Z"
        stroke={COLORS[color]}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default LikeIcon;
